/**
 * @generated SignedSource<<8c0f1e75a1df1bd9d1b7b4000e4a243e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ConsentStatus = "ACCEPTED" | "DECLINED" | "EXPIRED" | "NEW" | "RETIRED";
import { FragmentRefs } from "relay-runtime";
export type BarcModal_cookiesRef$data = {
  readonly cookies: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly consent: {
          readonly status: ConsentStatus;
        } | null;
        readonly cookieId: string;
        readonly description: string;
      };
    }>;
  } | null;
  readonly " $fragmentType": "BarcModal_cookiesRef";
};
export type BarcModal_cookiesRef$key = {
  readonly " $data"?: BarcModal_cookiesRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"BarcModal_cookiesRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BarcModal_cookiesRef",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CookieConnection",
      "kind": "LinkedField",
      "name": "cookies",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CookieEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Cookie",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cookieId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "description",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CookieConsent",
                  "kind": "LinkedField",
                  "name": "consent",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "bd6b72e99ce587faa357eebb2a7bcc01";

export default node;
